/* eslint-disable */
import { authTypes } from "../actions";

const initialState = {
  token: null,
  user: {},
  users: [],
  selectedUser: {},
  loading: false,
  error: null,
  requestLoginCodeSuccess: false,
  verifyLoginCodeSuccess: false,
};

const auth = (state = initialState, { type, payload }) => { // Change from 'login' to 'auth'
  switch (type) {
    case authTypes.REQUEST_LOGIN_CODE:
      return { 
        ...state, 
        loading: true, 
        error: null, 
        requestLoginCodeSuccess: false 
      };
    case authTypes.REQUEST_LOGIN_CODE_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        requestLoginCodeSuccess: true, 
        error: null 
      };
    case authTypes.VERIFY_LOGIN_CODE:
      return { 
        ...state, 
        loading: true, 
        error: null, 
        verifyLoginCodeSuccess: false 
      };
    case authTypes.VERIFY_LOGIN_CODE_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        verifyLoginCodeSuccess: true, 
        user: payload.user, 
        token: payload.token 
      };
    case authTypes.AUTH_ERROR:
      return { 
        ...state, 
        loading: false, 
        error: payload, 
        requestLoginCodeSuccess: false, 
        verifyLoginCodeSuccess: false 
      };
    case authTypes.LOG_IN_SUCCESS:
      return { ...state, user: payload.user, token: payload.token };
    case authTypes.LOGIN_SUCCESS_LOCAL_STORAGE: {
      return { ...state, user: payload.user, token: payload?.token };
    }
    case authTypes.LOAD_CREDENTIALS:
      return { ...state, ...payload };
    case authTypes.LOG_OUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
};

export default auth; // Change from 'login' to 'auth'